import { render, staticRenderFns } from "./AddNewAffiliatePopup.vue?vue&type=template&id=45c76646&"
import script from "./AddNewAffiliatePopup.vue?vue&type=script&lang=js&"
export * from "./AddNewAffiliatePopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports